<template>
  <div class="pa-4">
    <div class="d-flex flex-row-reverse">
      <v-row>
        <v-spacer class="py-0"></v-spacer>
        <v-col class="py-0" cols="6" md="5" lg="4" xl="3">
          <v-text-field
            background-color="white"
            outlined
            dense
            single-line
            rounded
            label="搜尋名稱、帳號"
            hide-details
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <div class="d-flex flex-row-reverse mt-4">
      <v-scroll-y-transition group>
        <v-btn
          depressed
          v-if="selectRow.length === 0"
          key="add"
          dark
          :color="$classStyle.addBtn"
          @click="$refs.editDialog.showCreateClinic()"
        >
          <v-icon left>mdi-plus</v-icon>
          <span class="subtitle-1">新增</span>
        </v-btn>
        <v-btn
          depressed
          color="error"
          v-else
          key="delete"
          @click="$refs.delConfirmDialog.showForDeleteClinic(selectRow)"
        >
          <span class="subtitle-1">刪除</span>
        </v-btn>
      </v-scroll-y-transition>
    </div>
    <v-card outlined class="mt-4">
      <v-data-table
        :class="[$globalStyle['manage-table'], $globalStyle['cross-row']]"
        show-select
        :headers="headers"
        :items="clinicItems"
        hide-default-footer
        item-key="clinic"
        :items-per-page="itemPerPage"
        :page="page"
        @input="selected => (selectRow = selected)"
        @current-items="items => (currentItems = items)"
        @click:row="
          item => {
            $refs.editDialog.showUpdateClinic(item);
          }
        "
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <span
              v-text="tableHint"
              :class="['body-2', $globalStyle.tableHeaderColor]"
            ></span>
            <v-spacer></v-spacer>
            <div class="d-inline-flex">
              <base-pagination
                v-model="page"
                :length="Math.ceil(clinicItems.length / itemPerPage)"
              ></base-pagination>
              <!-- <v-pagination
                v-model="page"
                :length="Math.ceil(clinicItems.length / itemPerPage)"
                :page="itemPerPage"
                total-visible="5"
              ></v-pagination> -->
            </div>
          </v-toolbar>
        </template>
        <template v-slot:header.data-table-select="{ props, on }">
          <div ref="unselectAll" @click="on.input(false)"></div>
          <v-checkbox
            color="cyan"
            hide-details
            class="mt-0"
            @click.stop="on.input(!props.value)"
            v-bind="props"
            v-on="on"
          ></v-checkbox>
        </template>
        <template v-slot:item.data-table-select="{ isSelected, select }">
          <v-checkbox
            color="cyan"
            hide-details
            :input-value="isSelected"
            @click.stop="select(!isSelected)"
            class="mt-0"
          ></v-checkbox>
        </template>
        <template v-slot:item.name="{ item }">
          <span class="black--text" v-text="item.name"></span>
        </template>
        <template v-slot:item.clinic="{ item }">
          <span class="black--text" v-text="item.clinic"></span>
        </template>
        <template v-slot:item.admin.phone="{ item }">
          <span class="black--text" v-text="item.admin.phone"></span>
        </template>
        <template v-slot:no-data>無資料</template>
      </v-data-table>
    </v-card>
    <clinic-manage-edit-dialog
      ref="editDialog"
      :clinicNames="clinicNames"
      @created="getAllClinic()"
      @updated="getAllClinic()"
    ></clinic-manage-edit-dialog>
    <dialog-delete-confirm
      ref="delConfirmDialog"
      @done="getAllClinic()"
    ></dialog-delete-confirm>
  </div>
</template>

<script>
import ClinicManageEditDialog from "./ClinicManageEditDialog";
import DialogDeleteConfirm from "../common/DialogDeleteConfirm";
import BasePagination from "../common/BasePagination";

export default {
  components: {
    ClinicManageEditDialog,
    DialogDeleteConfirm,
    BasePagination
  },
  data: () => ({
    page: 1,
    itemPerPage: 10,
    selectRow: [],
    currentItems: [],
    headers: [
      {
        text: "診所名稱",
        value: "name",
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"]
      },
      {
        text: "診所識別號",
        value: "clinic",
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"]
      },
      {
        text: "管理理員帳號",
        value: "admin.phone",
        class: ["subtitle-2", "font-weight-bold", "tableHeaderColor"]
      }
    ],
    clinicItems: [],
    deleteDialog: {
      loading: false,
      show: false,
      checkbox: false
    },
    clinicNames: []
  }),
  methods: {
    async getAllClinic() {
      this.$refs.unselectAll.click();
      let response = await this.$ajax.get(`${this.$config.apiUrl}/clinicAdmin`);
      console.log("clinicAdmin response:" + JSON.stringify(response.data));
      let adminRep = response.data;

      response = await this.$ajax.get(`${this.$config.apiUrl}/clinicData/0`);
      let clinicRep = response.data;
      console.log("clinicData response:" + JSON.stringify(response.data));

      clinicRep.forEach(clinic => {
        let index = 0;
        while (!clinic.admin && index < adminRep.length) {
          if (adminRep[index].clinic === clinic.clinic) {
            clinic.admin = adminRep[index];
          }
          index++;
        }
      });
      console.log("clinicRep:" + JSON.stringify(clinicRep));
      this.clinicItems = clinicRep;
    }
  },
  computed: {
    tableHint() {
      if (this.selectRow.length > 0) {
        return `已選取${this.selectRow.length}間診所`;
      } else {
        let start = (this.page - 1) * this.itemPerPage + 1;
        let end = start + this.currentItems.length - 1;
        return `${start}-${end}筆,共${this.clinicItems.length}筆資料`;
      }
    }
  },
  mounted() {
    this.getAllClinic();
  }
};
</script>
